<template>
  <article class="debtor-section">
    <v-data-table
      class="debtor-table mobile-scroll-table1"
      :headers="headers"
      :items="debtors"
      :items-per-page="-1"
      hide-default-footer
      fixed-header
      disable-sort
    >
      <template v-slot:item.totalBalance="{ item }">
        <div class="text-no-wrap">
          {{ item.totalBalance | amountWithCurrency0 }}
        </div>
      </template>
      <template v-slot:item.cashBalance="{ item }">
        <div class="text-no-wrap">
          {{ item.cashBalance | amountWithCurrency0 }}
        </div>
      </template>
      <template v-slot:item.terminalBalance="{ item }">
        <div class="text-no-wrap">
          {{ item.terminalBalance | amountWithCurrency0 }} ({{ item.checksCount }})
        </div>
      </template>
      <template #no-data>
        <span></span>
      </template>
      <template #footer>
        <div v-if="!debtors.length" class="debtor-section-no-data">
          <span>Отсутствуют данные</span>
        </div>
      </template>
    </v-data-table>
  </article>
</template>

<script>
  export default {
    name: 'DebtorsTable',
    props: {
      debtors: Array,
    },
    data () {
      return {
        headers: [
          { text: 'Курьер', value: 'name', width: '50%' },
          { text: 'Общий баланс', value: 'totalBalance', align: 'center' },
          { text: 'Наличные', value: 'cashBalance', align: 'center' },
          { text: 'Терминал', value: 'terminalBalance', align: 'center' },
        ],
      }
    },
  }
</script>

<style scoped lang="less">
.debtor-section {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: @color-secondary;
  padding: 15px 15px;
  border-radius: 10px;

  &-no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.38);
    font-size: 20px;
  }
}

.debtor-table {
  position: relative;
}

::v-deep {
  .v-data-table {
    flex-grow: 1;

    &__wrapper {
      height: 350px;
      max-height: 350px;
    }
  }
}
</style>
